import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['mapState'])
  },
  methods: {
    checkAdmin () {
      if (this.profile.type > 2) {
        this.$router.replace('/')
      }
    }
  },
  created () {
    this.checkAdmin()
  },
  watch: {
    profile: {
      handler () {
        this.checkAdmin()
      },
      deep: true
    }
  }
}
